export const SET_LOGGED = "SET_LOGGED ";

export function setLogged(logged: boolean) {
  return { type: SET_LOGGED as typeof SET_LOGGED, logged };
}

export const RESET_STORE = "RESET_STORE";

export function logOut() {
  return { type: RESET_STORE as typeof RESET_STORE };
}

export type Actions = ReturnType<typeof setLogged> | ReturnType<typeof logOut>;



// WEBPACK FOOTER //
// ./src/redux/logged/actions.ts